import React from "react";
import {
  Flex,
  Link,
  HStack,
  IconButton,
  Box,
  Heading,
  Button,
  Tooltip,
  Text,
} from "@chakra-ui/react";
import { BsGithub, BsLinkedin, BsMouse } from "react-icons/bs";
import { TypeAnimation } from "react-type-animation";
import { MotionBox, Reveal } from "./story";

function Home() {
  return (
    <Box
      id="Home"
      minH="100vh"
      w="100%"
      px={{ base: "8%", md: "10%" }}
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      position="relative"
    >
      {/* opening line of the story */}
      <Reveal>
        <Text
          letterSpacing="0.35em"
          fontSize={{ base: "10px", md: "sm" }}
          color="#60A5FA"
          textTransform="uppercase"
          fontWeight="bold"
          mb="20px"
        >
          Prologue · This is my story
        </Text>
      </Reveal>

      {/* name */}
      <Reveal delay={0.1}>
        <Heading
          as="h1"
          fontSize={{ base: "36px", md: "68px", lg: "84px" }}
          fontWeight="900"
          lineHeight="1.05"
        >
          Hi, I'm{" "}
          <Box
            as="span"
            bgGradient="linear(to-r, #60A5FA, #93C5FD)"
            bgClip="text"
          >
            Mukul Jatav
          </Box>
        </Heading>
      </Reveal>

      {/* role */}
      <Reveal delay={0.2}>
        <Heading
          as="h2"
          mt="10px"
          fontSize={{ base: "20px", md: "34px", lg: "40px" }}
          fontWeight="700"
          color="#e6e9f0"
        >
          Software Engineer
        </Heading>
      </Reveal>

      {/* animated tagline */}
      <Reveal delay={0.3}>
        <Heading
          size="lg"
          color="#60A5FA"
          mt="14px"
          minH={{ base: "28px", md: "40px" }}
          fontWeight="600"
        >
          <TypeAnimation
            cursor={true}
            sequence={[
              "I turn ideas into products",
              2000,
              "I build software that scales",
              2000,
              "I write stories in code",
              2000,
            ]}
            preRenderFirstString={true}
            speed={200}
            repeat={Infinity}
          />
        </Heading>
      </Reveal>

      {/* one-line hook */}
      <Reveal delay={0.4}>
        <Text
          mt="24px"
          maxW="560px"
          color="#98a2b8"
          fontSize={{ base: "sm", md: "md" }}
          lineHeight="1.9"
        >
          Every product begins with a single line of code, and every engineer
          with a single line of curiosity. Scroll down and let me walk you
          through mine, one chapter at a time.
        </Text>
      </Reveal>

      {/* CTAs */}
      <Reveal delay={0.5}>
        <HStack mt="34px" spacing={4} flexWrap="wrap" justify="center">
          <Link
            href="https://drive.google.com/file/d/1VxMZc50-Z8Ne1NRK3XVaBbhbscVWlvpG/view?usp=sharing"
            isExternal
            _hover={{ textDecoration: "none" }}
          >
            <Button
              bg="#60A5FA"
              color="white"
              h="48px"
              px="28px"
              fontWeight="700"
              _hover={{
                bg: "transparent",
                border: "2px solid #60A5FA",
                color: "#60A5FA",
                transform: "translateY(-2px)",
              }}
              transition="all 0.25s"
            >
              Resume
            </Button>
          </Link>
          <Link href="#Contact" _hover={{ textDecoration: "none" }}>
            <Button
              variant="outline"
              borderColor="rgba(255,255,255,0.2)"
              color="#e6e9f0"
              h="48px"
              px="28px"
              fontWeight="700"
              _hover={{ borderColor: "#60A5FA", color: "#60A5FA" }}
              transition="all 0.25s"
            >
              Say Hello
            </Button>
          </Link>
        </HStack>
      </Reveal>

      {/* socials */}
      <Reveal delay={0.6}>
        <HStack pt="26px" spacing={3}>
          <Tooltip label="Let's connect on LinkedIn" hasArrow bg="#60A5FA" color="white">
            <Link href="https://www.linkedin.com/in/mukul-jatav/" isExternal>
              <IconButton
                aria-label="LinkedIn"
                variant="ghost"
                size="lg"
                isRound
                color="#98a2b8"
                _hover={{ bg: "#60A5FA", color: "white" }}
                icon={<BsLinkedin size="24px" />}
              />
            </Link>
          </Tooltip>
          <Tooltip label="My GitHub" hasArrow bg="#60A5FA" color="white">
            <Link href="https://github.com/mukulsomukesh" isExternal>
              <IconButton
                aria-label="GitHub"
                variant="ghost"
                size="lg"
                isRound
                color="#98a2b8"
                _hover={{ bg: "#60A5FA", color: "white" }}
                icon={<BsGithub size="24px" />}
              />
            </Link>
          </Tooltip>
        </HStack>
      </Reveal>

      {/* scroll cue */}
      <MotionBox
        position="absolute"
        bottom={{ base: "24px", md: "34px" }}
        left="50%"
        style={{ translateX: "-50%" }}
        animate={{ y: [0, 10, 0], opacity: [0.4, 1, 0.4] }}
        transition={{ duration: 1.8, repeat: Infinity }}
        color="#98a2b8"
      >
        <Flex direction="column" align="center" gap="6px">
          <BsMouse size="22px" />
          <Text fontSize="10px" letterSpacing="0.2em">
            SCROLL
          </Text>
        </Flex>
      </MotionBox>
    </Box>
  );
}

export default Home;
